import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { addDays, format } from "date-fns";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import { Button, DatePicker, Pagination, Spin } from "antd";
import { getValue, getDate } from "../../../services/functions";
import { Message } from "../../../GlobalStyles";

export default function FinanceiroAdmin({ type }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({});
  const [orders, setOrders] = useState([]);
  const [ordersTotal, setOrdersTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [totalServices, setTotalServices] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [startDate, setStartDate] = useState(addDays(new Date(), -30));
  const [endDate, setEndDate] = useState(new Date());

  useEffect(() => {
    if (user) {
      loadingOSs();
    }
  }, [user, startDate, endDate]);

  useEffect(() => {
    loadingUser();
  }, []);

  async function loadingUser() {
    await api
      .get(`/${type}/${id}`)
      .then((response) => {
        setUser(response.data);
        loadingOSs(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
        navigate(-1);
      });
  }

  async function loadingOSs() {
    setLoading(true);
    user.type = type == "user" ? "cliente" : "tecnico";
    await api
      .get(
        `/orders/${user.type}?id=${id}&page${page}&startDate=${startDate}&endDate=${endDate}&finance=true`
      )
      .then((response) => {
        setTotalValue(
          type == "user"
            ? response.data.totalValue
            : response.data.totalValueComission
        );
        setTotalServices(response.data.totalServices);
        setOrders(response.data.orders);
        setOrdersTotal(response.data.ordersTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1>Finanças {user.name}</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
            width: 150,
            marginRight: 20,
          }}
          onClick={() => {
            toast.warn("Ocorreu um erro ao gerar relátorio");
          }}
        >
          Gerar Relátorio
        </Button>
      </div>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <p className="titleInput">Selecione o Periodo</p>
          <DatePicker.RangePicker
            placeholder={["data inicial", "data final"]}
            value={[
              startDate ? dayjs(startDate) : "",
              endDate ? dayjs(endDate) : "",
            ]}
            locale={locale}
            format={"DD/MM/YYYY"}
            onChange={(value, dateString) => {
              setStartDate(getDate(dateString[0]));
              setEndDate(getDate(dateString[1]));
              setPage(0);
            }}
            allowClear={false}
            style={{ width: 380 }}
            onOk={() => {}}
          />
          {!!ordersTotal && (
            <>
              <p className="resumo">
                <strong>{ordersTotal}</strong> OSs e{" "}
                <strong>{totalServices}</strong> serviços{" "}
                {type == "user" ? "solicitados" : "realizados"}
              </p>

              <p className="resumo" style={{ marginTop: 10 }}>
                <strong>{getValue(totalValue || 0)}</strong> total
              </p>
              {user.type == "cliente" && (
                <p
                  className="resumo"
                  style={{ marginTop: 5, marginBottom: 10 }}
                >
                  <strong>{getValue(totalValue * 3 || 0)}</strong> média de
                  faturamento
                </p>
              )}
            </>
          )}
          <div className="orders" style={{ marginTop: 5, marginTop: 10 }}>
            {!ordersTotal && (
              <Message>Nenhuma OS finalizada nesse periodo</Message>
            )}
            {orders.map((item) => {
              return (
                <div className="order">
                  <p className="title">
                    <a
                      className="link"
                      onClick={() => {
                        navigate("/admin/os/" + item.id);
                      }}
                    >
                      {item.name
                        ? item.name + " - " + ("0000" + item.id).slice(-4)
                        : ("0000" + item.id).slice(-4)}
                    </a>
                  </p>
                  <div className="backGreen">
                    {item.totalServices} serviços solicitados
                  </div>
                  <div className="row">
                    <div className="back">
                      Finalizado em{" "}
                      {format(new Date(item.update_at), "dd/MM/yyyy HH:mm")}
                    </div>
                    <div className="back">
                      <strong>
                        {getValue(
                          type == "user"
                            ? item.totalValue
                            : item.totalValueComission || 0
                        )}
                      </strong>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {!!ordersTotal && (
            <Pagination
              style={{
                margin: "25px 0",
                alignSelf: "center",
              }}
              defaultCurrent={page + 1}
              pageSize={30}
              onChange={(page) => {
                setPage(page - 1);
              }}
              total={ordersTotal}
            />
          )}
        </>
      )}
    </Container>
  );
}
